"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionShowGlobalErrorDialog = exports.actionHideGlobalErrorDialog = void 0;
var _actions = require("../../modal/actions");
var _dialogs = require("../constants/dialogs");
var actionShowGlobalErrorDialog = exports.actionShowGlobalErrorDialog = function actionShowGlobalErrorDialog() {
  return function (dispatch) {
    return dispatch((0, _actions.actionShowModal)(_dialogs.MODAL_DIALOG__ERROR));
  };
};
var actionHideGlobalErrorDialog = exports.actionHideGlobalErrorDialog = function actionHideGlobalErrorDialog() {
  return function (dispatch) {
    return dispatch((0, _actions.actionHideModal)(_dialogs.MODAL_DIALOG__ERROR));
  };
};